<div
  style="margin: 20px auto; width: auto"
  ngStyle.lt-lg="width: 900px"
  ngStyle.lt-md="width: 100%"
>
  <!--  <app-breadcrumb></app-breadcrumb>-->
  <h4 style="font-size: 18px; margin-left: 20px" class="fc_DEDEDE">
    Edit your company profile
  </h4>
  <div
    style="
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
        0 2px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      background: #161616;
      padding: 20px;
    "
  >
    <h4 style="margin-top: 0" class="fc_DEDEDE">Company Logo</h4>
    <div
      style="
        width: 300px;
        height: 200px;
        border: 1px solid #ebebeb;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <ng-container *ngIf="company">
        <img
          *ngIf="company.logo"
          [src]="
            SERVER_URL +
            'images/company_' +
            company.id +
            '/' +
            company.logo.fileName
          "
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <img
          *ngIf="!company.logo"
          src="./assets/images/default-images.svg"
          style="width: 93px; height: 82px; object-fit: cover"
        />
      </ng-container>
    </div>
    <input
      #logo
      accept="image/*"
      style="display: none"
      type="file"
      class="form-control"
      multiple=""
      (change)="onFeatureImageChange($event)"
    />
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <button
        (click)="logo.click()"
        mat-button
        style="border: 1px solid #dedede; color: #dedede"
      >
        Click here to change a logo (max 1MB)
      </button>
    </div>
    <ng-container *ngIf="selectedImage.length > 0">
      <p class="upload_images flex align-center justify-center">
        Successfully uploaded
        <mat-icon style="color: #dedede; margin-right: 30px">check</mat-icon>
      </p>
      <p
        *ngFor="let file of selectedImage"
        style="color: #dedede; font-size: 14px; margin-top: 10px"
      >
        {{ file.name }} ({{ (file.size / 1048).toFixed(0) }} KB)
      </p>
    </ng-container>
    <div style="width: 100%; display: flex; justify-content: flex-end">
      <button
        mat-button
        type="submit"
        class="submit_company_button"
        [disabled]="selectedImage.length < 1"
        [ngClass]="{
          deactivated: selectedImage.length === 0,
          activated: selectedImage.length !== 0
        }"
        (click)="uploadLogo()"
      >
        Upload
      </button>
    </div>
  </div>
  <div
    style="
      margin-top: 20px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
        0 2px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      background: #161616;
      padding: 20px;
    "
  >
    <h4 style="margin-top: 0; color: #dedede">Company Banner</h4>
    <div
      style="
        width: 300px;
        height: 200px;
        border: 1px solid #ebebeb;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <ng-container *ngIf="company">
        <img
          *ngIf="company.banner"
          [src]="
            SERVER_URL +
            'images/company_' +
            company.id +
            '/' +
            company.banner.fileName
          "
          style="width: 100%; height: 100%; object-fit: contain"
        />
        <!--                <img *ngIf="!company.banner" src="./assets/images/default-images.svg"-->
        <!--                     style="width: 93px; height: 82px; object-fit: cover">-->
      </ng-container>
    </div>
    <input
      #banner
      accept="image/*"
      style="display: none"
      type="file"
      class="form-control"
      multiple=""
      (change)="onBannerImageChange($event)"
    />
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <button
        (click)="banner.click()"
        mat-button
        style="border: 1px solid #dedede; background: #161616; color: #dedede"
      >
        Click here to change a banner (max 1MB)
      </button>
    </div>
    <ng-container *ngIf="selectedBanner.length > 0">
      <p
        *ngFor="let file of selectedBanner"
        class="upload_images flex align-center justify-center"
      >
        <mat-icon style="color: #dedede; margin-right: 5px"
          >insert_drive_file</mat-icon
        >
        {{ file.name }} ({{ (file.size / 1048).toFixed(0) }} KB)
      </p>
    </ng-container>
    <div style="width: 100%; display: flex; justify-content: flex-end">
      <button
        mat-button
        type="submit"
        class="submit_company_button"
        [disabled]="selectedBanner.length < 1"
        [ngClass]="{
          deactivated: selectedBanner.length === 0,
          activated: selectedBanner.length !== 0
        }"
        (click)="uploadBanner()"
      >
        Upload
      </button>
    </div>
  </div>

  <div
    style="
      margin-top: 20px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
        0 2px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      background: #161616;
      padding: 20px;
    "
  >
    <h4 style="margin-top: 0; color: #dedede">Company Info</h4>
    <form [formGroup]="reactiveForm">
      <div style="display: flex; flex-direction: column">
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Company name </mat-label>
            <input matInput formControlName="companyName" />
          </mat-form-field>
          <!--        <mat-form-field appearance="outline">-->
          <!--          <mat-label>-->
          <!--            ABN-->
          <!--          </mat-label>-->
          <!--          <input matInput formControlName="abn">-->
          <!--        </mat-form-field>-->

          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Website (optional) </mat-label>
            <input matInput formControlName="website" />
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Email </mat-label>
            <input matInput formControlName="email" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Contact Number </mat-label>
            <input matInput formControlName="phoneNumber" />
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label> Description (optional) </mat-label>
          <textarea
            matInput
            formControlName="description"
            style="height: 150px"
          ></textarea>
        </mat-form-field>
        <h4 style="">Company Address</h4>
        <app-auto-complete
          (setAddress)="getAddress($event)"
          addressType="geocode"
          [style]="style"
        >
        </app-auto-complete>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Address line1 (optional) </mat-label>
            <input matInput formControlName="addressLine1" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Address line2 </mat-label>
            <input matInput formControlName="addressLine2" />
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Suburb </mat-label>
            <input matInput formControlName="area" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> State </mat-label>
            <input matInput formControlName="state" />
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Post code </mat-label>
            <input matInput formControlName="postCode" />
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 45%">
            <mat-label> Country </mat-label>
            <input matInput formControlName="country" />
          </mat-form-field>
        </div>
      </div>
      <div style="width: 100%; display: flex; justify-content: flex-end">
        <button
          mat-button
          style="background: #161616; color: #dedede; border: 1px solid #dedede"
          (click)="updateCompanyInfo()"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
